import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { IPlanUsageRequest } from '../../interfaces/plan-usage';
import { StateStructure } from '@ptl/state';
import { NgRedux } from '@ptl/angular-redux-store';
import { setRecommendPlansFlowUsageCode } from '../../configs/reducers/plans.reducer';
import { MatSnackBar } from '@angular/material/snack-bar';

import { GlobalShadowStyleDirective } from '@ptl/global-components';

enum USAGE_CODE_BY_USAGE_LEVEL {
  BASIC = 0,
  LOW = 1,
  MODERATE = 2,
  HIGH = 3,
}

@Component({
    selector: 'app-plan-usage',
    templateUrl: './plan-usage.component.html',
    styleUrls: ['./plan-usage.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class PlanUsageComponent extends GlobalShadowStyleDirective implements OnInit {

  @Input() nextPageUrl: string;

  templateUsageCodeByUsageLevel = {
    BASIC: USAGE_CODE_BY_USAGE_LEVEL.BASIC,
    LOW: USAGE_CODE_BY_USAGE_LEVEL.LOW,
    MODERATE: USAGE_CODE_BY_USAGE_LEVEL.MODERATE,
    HIGH: USAGE_CODE_BY_USAGE_LEVEL.HIGH
  };

  viewMore = [false, false, false, false];
  selectedUsageCode: USAGE_CODE_BY_USAGE_LEVEL = null;
  planUsageRequest: IPlanUsageRequest;

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private snackBar: MatSnackBar
  ) {
    super();
   }

  ngOnInit() { }

  toggleViewMoreLess(e, boxIndex) {
    this.viewMore[boxIndex] = !this.viewMore[boxIndex];
  }

  selectPlan(e, usageCode: USAGE_CODE_BY_USAGE_LEVEL) {
    this.selectedUsageCode = usageCode;
  }

  nextClicked(e) {
    this.ngRedux.dispatch(setRecommendPlansFlowUsageCode(this.selectedUsageCode));
    if (this.nextPageUrl) {

      const alertDuration = 1000; // ms

      this.snackBar.open(`Saving information, will continue shortly.`, 'OK', {
        duration: alertDuration,
        panelClass: 'positive-panel-class'
      });

      setTimeout(() => {
        window.location.href = `./${this.nextPageUrl}`;
      }, alertDuration)
    }
  }
}
